// This file uses commonJS exports because it's referenced in our webpack build
"use strict";

/**
 * Convert a string to a string that is safe for use in a variable name.
 * @param name string to be converted
 * @return var-name-safe value
 */
function toVarName(name) {
  return name.toLowerCase().replace(/[^_a-z0-9]/g, "_");
}

module.exports = toVarName;
